export default {
  cards: {
    chart: {
      sebaranProvinsi: {
        queryName: "kemenag-top-provinsi",
        content: {
          title: "Sebaran Provinsi Terbanyak",
          showTitle: true,
          subtitle: "Pondok Pesantren di Indonesia",
          showSubtitle: true,
          showIcon: false,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
          info: "#### Sebaran jumlah pesantren berdasarkan provinsi",
          showInfo: true,
        },
        options: {
          columns: [
            {
              title: "Provinsi",
              dataIndex: "name",
            },
            {
              title: "Jumlah",
              dataIndex: "value",
            },
          ],
          chartOption: {
            tooltip: {
              trigger: "item",
            },
            grid: {
              left: 40,
              right: 0,
              top: 20,
              bottom: 20,
            },
            dataset: [
              {
                dimensions: ["Provinsi", "Total"],
              },
              {
                transform: {
                  type: "sort",
                  config: { dimension: "Total", order: "asc" },
                },
              },
            ],
            xAxis: {
              show: false,
              axisLabel: { show: false },
              axisLine: { show: false },
              axisTick: { show: false },
              splitLine: { show: false },
            },
            yAxis: {
              type: "category",
              show: false,
              axisLabel: { show: false },
              axisLine: { show: false },
              axisTick: { show: false },
              splitLine: { show: false },
            },
            series: {
              type: "bar",
              showBackground: true,
              datasetIndex: 1,
              barCategoryGap: "70%",
              label: {
                show: true,
                fontSize: 18,
                position: "top",
                formatter: (value) => {
                  return value.data[0];
                },
                color: "#000",
              },
              itemStyle: {
                normal: {
                  color: "#1B6FBA",
                },
              },
            },
          },
          dataSource: [],
          style: {
            height: 820,
          },
        },
        state: {
          limit: 10,
        },
      },
      sebaranKabupaten: {
        queryName: "kemenag-top-kabupaten",
        content: {
          title: "Sebaran Kabupaten Terbanyak",
          showTitle: true,
          subtitle: "Pondok Pesantren di Indonesia",
          showSubtitle: true,
          showIcon: false,
          showSaveAsImage: true,
          showTable: false,
          showDownloadTable: false,
          info: "#### Sebaran jumlah pesantren berdasarkan kabupaten",
          showInfo: true,
        },
        options: {
          chartOption: {
            grid: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
            },
            tooltip: false,
            animation: false,
            series: [
              {
                type: "graph",
                layout: "force",
                roam: true,
                force: {
                  repulsion: 140,
                },
                label: {
                  show: true,
                  position: "inside",
                  align: "center",
                  formatter: `{c} \n {b}`,
                  color: "#ffffff",
                },
                itemStyle: {
                  normal: {
                    color: (params) => {
                      const colorList = [
                        "#FF4DB3",
                        "#9650FF",
                        "#FFA358",
                        "#69D629",
                        "#83FF98",
                        "#4ECFFF",
                        "#6AAEFF",
                        "#98B2FF",
                        "#989EFF",
                        "#B298FF",
                      ];
                      return colorList[params.dataIndex];
                    },
                  },
                },
              },
            ],
          },
          style: {
            height: 580,
          },
        },
        state: {
          limit: 10,
        },
      },
      sebaranBentukUsaha: {
        queryName: "kemenag-bentuk-usaha",
        content: {
          title: "Sebaran Bentuk Usaha",
          showTitle: true,
          subtitle: "Pondok Pesantren di Indonesia",
          showSubtitle: true,
          showIcon: false,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
          info: "#### Sebaran jumlah pesantren berdasarkan bentuk usaha",
          showInfo: true,
        },
        options: {
          columns: [
            {
              title: "Bentuk Usaha",
              dataIndex: "name",
            },
            {
              title: "Jumlah",
              dataIndex: "value",
            },
          ],
          chartOption: {
            grid: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
            },
            tooltip: {
              trigger: "item",
            },
            dataset: [
              {
                dimensions: ["Bentuk Usaha", "Total"],
              },
              {
                transform: {
                  type: "sort",
                  config: { dimension: "Total", order: "asc" },
                },
              },
            ],
            xAxis: {
              show: false,
              axisLabel: { show: false },
              axisLine: { show: false },
              axisTick: { show: false },
            },
            yAxis: {
              type: "category",
              show: false,
              axisLabel: { show: false },
              axisLine: { show: false },
              axisTick: { show: false },
              splitLine: { show: false },
            },
            series: {
              type: "bar",
              barWidth: 25,
              showBackground: true,
              datasetIndex: 1,
              label: {
                show: true,
                position: [0, -20],
                formatter: `{c}`,
              },
              itemStyle: {
                normal: {
                  color: (params) => {
                    const colorList = [
                      "#FF4DB3",
                      "#9650FF",
                      "#FFA358",
                      "#69D629",
                      "#83FF98",
                      "#4ECFFF",
                      "#6AAEFF",
                      "#98B2FF",
                      "#989EFF",
                      "#B298FF",
                    ];
                    return colorList[params.dataIndex];
                  },
                },
              },
            },
          },
          dataSource: [],
        },
        state: {
          limit: 6,
        },
      },
      sebaranJenisUsaha: {
        queryName: "kemenag-jenis-usaha",
        content: {
          title: "Sebaran Jenis Usaha",
          showTitle: true,
          subtitle: "Pondok Pesantren di Indonesia",
          showSubtitle: true,
          showIcon: false,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
          info: "#### Sebaran jumlah pesantren berdasarkan jenis usaha",
          showInfo: true,
        },
        options: {
          columns: [
            {
              title: "Jenis Usaha",
              dataIndex: "name",
            },
            {
              title: "Jumlah",
              dataIndex: "value",
            },
          ],
          chartOption: {
            grid: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
            },
            tooltip: {
              trigger: "item",
            },
            dataset: [
              {
                dimensions: ["Jenis Usaha", "Total"],
              },
              {
                transform: {
                  type: "sort",
                  config: { dimension: "Total", order: "desc" },
                },
              },
            ],
            angleAxis: {
              max: (value) => {
                return value.max + 60;
              },
            },
            radiusAxis: {
              type: "category",
              axisLabel: {
                show: false,
              },
            },
            polar: {},
            series: [
              {
                type: "bar",
                coordinateSystem: "polar",
                label: {
                  show: true,
                },
                itemStyle: {
                  normal: {
                    color: (params) => {
                      const colorList = [
                        "#FF4DB3",
                        "#9650FF",
                        "#FFA358",
                        "#69D629",
                        "#83FF98",
                        "#4ECFFF",
                        "#6AAEFF",
                        "#98B2FF",
                        "#989EFF",
                        "#B298FF",
                      ];
                      return colorList[params.dataIndex];
                    },
                  },
                },
              },
            ],
          },
          dataSource: [],
          style: {
            height: 480,
          },
        },
        state: {
          limit: 9,
        },
      },
      sebaranOrmas: {
        queryName: "kemenag-afiliasi",
        content: {
          title: "Sebaran Ormas",
          showTitle: true,
          subtitle: "Afiliasi Pesantren di Indonesia",
          showSubtitle: true,
          showIcon: false,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
          info: "#### Sebaran jumlah pesantren berdasarkan ormas",
          showInfo: true,
        },
        options: {
          columns: [
            {
              title: "Ormas",
              dataIndex: "name",
            },
            {
              title: "Total",
              dataIndex: "value",
            },
          ],
          chartOption: {
            grid: {
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
            },
            tooltip: {
              trigger: "item",
            },
            series: [
              {
                type: "pie",
                radius: [50, 100],
                center: ["50%", "50%"],
                roseType: "area",
                top: 50,
                itemStyle: {
                  normal: {
                    borderRadius: 8,
                    color: (params) => {
                      const colorList = [
                        "#FF4DB3",
                        "#9650FF",
                        "#FFA358",
                        "#69D629",
                        "#83FF98",
                        "#4ECFFF",
                        "#6AAEFF",
                        "#98B2FF",
                        "#989EFF",
                        "#B298FF",
                      ];
                      return colorList[params.dataIndex];
                    },
                  },
                },
              },
            ],
          },
          dataSource: [],
          style: {
            height: 480,
          },
        },
        state: {
          limit: 8,
        },
      },
      sebaranAsosiasi: {
        queryName: "kemenag-asosiasi",
        content: {
          title: "Sebaran Asosiasi",
          showTitle: true,
          subtitle: "Afiliasi Pesantren di Indonesia",
          showSubtitle: true,
          showIcon: false,
          showSaveAsImage: true,
          showTable: true,
          showDownloadTable: true,
          info: "#### Sebaran jumlah pesantren berdasarkan asosiasi",
          showInfo: true,
        },
        options: {
          columns: [
            {
              title: "Asosiasi",
              dataIndex: "name",
            },
            {
              title: "Total",
              dataIndex: "value",
            },
          ],
          chartOption: {
            grid: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
            },
            tooltip: {
              trigger: "item",
            },
            dataset: [
              {
                dimensions: ["Asosiasi", "Total"],
              },
              {
                transform: {
                  type: "sort",
                  config: { dimension: "Total", order: "asc" },
                },
              },
            ],
            xAxis: {
              show: false,
              axisLabel: { show: false },
              axisLine: { show: false },
              axisTick: { show: false },
            },
            yAxis: {
              type: "category",
              show: false,
              axisLabel: { show: false },
              axisLine: { show: false },
              axisTick: { show: false },
              splitLine: { show: false },
            },
            series: {
              type: "bar",
              barWidth: 25,
              showBackground: true,
              datasetIndex: 1,
              label: {
                show: true,
                position: [0, -20],
                formatter: `{c}`,
              },
              itemStyle: {
                normal: {
                  color: (params) => {
                    const colorList = [
                      "#FF4DB3",
                      "#9650FF",
                      "#FFA358",
                      "#69D629",
                      "#83FF98",
                      "#4ECFFF",
                      "#6AAEFF",
                      "#98B2FF",
                      "#989EFF",
                      "#B298FF",
                    ];
                    return colorList[params.dataIndex];
                  },
                },
              },
            },
          },
          dataSource: [],
        },
        state: {
          limit: 4,
        },
      },
    },
  },
};
